import { useParams } from "react-router-dom"
import React, { useEffect, useState } from "react"

import { L0GXP } from "../../api/Registry"
import HttpServices from "../../services/HttpServices"
import { BespokePanel } from "../../lib/fragments/BespokePanel"
import { RouteHydration, DateFormating, classNames, displayNameColoring } from "../../utils/Helpers"

export const ExplorerDetails = ({ show, showOrHide, uuid }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'fulfilled',
        data: {
            logEntry: null,
            actor: null,
            target: null,
            meta: null,
            snapshot: null,
        }
    })

    const params = useParams()

    const logXplorerViewLogEntry = async () => {
        setstate(prevState => ({
            ...prevState,
            status: 'pending'
        }));

        let { status, httpStatus, data } = state

        try {
            const logEntryRoute = [":logId"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [uuid][index]),
                    L0GXP.EVENT_DETAILS
                );

            const response: any = await HttpServices.httpGet(logEntryRoute)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload;
                const entryDetails = payload.details

                const logEntry = {
                    eid: entryDetails.eid,
                    event: entryDetails.event,
                    summary: entryDetails.summary,
                    description: entryDetails.description,
                    timestamp: entryDetails.timestamp,
                    log: entryDetails.log,
                }

                data.logEntry = logEntry
                data.meta = entryDetails.meta
                data.actor = entryDetails.actor
                data.target = entryDetails.target
                data.snapshot = entryDetails.snapshot

                status = 'fulfilled'
            } else {
                status = 'rejected'
            }
        } catch (error) {
            status = 'rejected'
            httpStatus = 500
        }

        setstate((prevState: any) => ({
            ...prevState,
            status,
            httpStatus,
            data: {
                ...prevState.data,
            },
        }));
    }

    useEffect(() => {
        if (show) {
            logXplorerViewLogEntry()
        }
    }, [show])

    const jsonData = {
        user: "John Doe",
        role: "Admin",
        active: true,
        permissions: ["read", "write", "delete"]
    };

    return (
        <React.Fragment>
            <BespokePanel
                show={show}
                title={undefined}
                description={
                    <>
                        <div className="pb-2 w-full">
                            <span className="block text-sm text-slate-400 dark:text-slate-500">
                                {DateFormating(state.data.logEntry?.timestamp, 'D MMM YYYY, hh:mm A')}
                            </span>
                        </div>

                        <h2 className="text-xl text-slate-800 dark:text-slate-200 mb-3 flex gap-x-3">
                            <div className="flex-none">
                                <span className={classNames(
                                    state.data.logEntry?.log === 'info' && 'bg-blue-100 dark:bg-blue-800/40 text-blue-500 dark:text-blue-400',
                                    state.data.logEntry?.log === 'warn' && 'bg-amber-100 dark:bg-amber-800/40 text-amber-500 dark:text-amber-400',
                                    state.data.logEntry?.log === 'error' && 'bg-red-100 dark:bg-red-800/40 text-red-500 dark:text-red-400',
                                    state.data.logEntry?.log === 'notice' && 'bg-purple-100 dark:bg-purple-800/40 text-purple-500 dark:text-purple-400',
                                    " rounded-md px-1.5 py-1 text-xs ring-0 ring-inset capitalize"
                                )}>
                                    {state.data.logEntry?.log}
                                </span>
                            </div>

                            {state.data.logEntry?.summary}
                        </h2>

                        <p
                            className="text-sm text-slate-500 dark:text-slate-400"
                            dangerouslySetInnerHTML={{ __html: state.data.logEntry?.description ?? '' }}
                        />
                    </>
                }
                status={state.status}
                showOrHide={showOrHide}
                httpStatus={state.httpStatus}
                components={
                    <>
                        <div className="w-full px-4 md:px-5 text-sm">
                            <span className="block text-slate-800 dark:text-slate-200 mt-1 mb-1">
                                Meta
                            </span>

                            <div className="w-full py-2 flex align-middle items-center text-sm">
                                <div className="w-1/3">
                                    <span className="block text-slate-500 dark:text-slate-500">
                                        Module
                                    </span>
                                </div>

                                <div className="w-2/3">
                                    <span className="block text-sm text-slate-700 dark:text-slate-300">
                                        {state.data.logEntry?.event}
                                    </span>
                                </div>
                            </div>

                            <div className="w-full pt-2 pb-2 flex align-middle items-center text-sm">
                                <div className="w-1/3">
                                    <span className="block text-slate-500 dark:text-slate-500">
                                        IP Address
                                    </span>
                                </div>

                                <div className="w-2/3">
                                    <span className="block text-sm text-slate-700 dark:text-slate-300">
                                        {state.data.meta?.ip_address}
                                    </span>
                                </div>
                            </div>

                            <div className="w-full pt-2 pb-2 grid grid-cols-[1fr_2fr]">
                                <div>
                                    <span className="block text-slate-500 dark:text-slate-500">
                                        User Agent
                                    </span>
                                </div>

                                <div>
                                    <span className="block text-sm text-slate-700 dark:text-slate-300">
                                        {state.data.meta?.agent.replace(/browser:\s*|mobile:\s*/gi, '').trim()}
                                    </span>
                                </div>
                            </div>

                            <div className="w-full pt-2 pb-6 flex">
                                <div className="w-1/3">
                                    <span className="block text-slate-500 dark:text-slate-500">
                                        Actioned By
                                    </span>
                                </div>

                                <div className="w-2/3">
                                    <div className="w-full flex flex-row items-center gap-x-3 text-sm text-stone-500 hover:bg-stone-00 hover:text-stone-700 align-middle overflow-hidden">
                                        {
                                            !state.data.actor?.photo_url ? (
                                                <>
                                                    {
                                                        state.data.actor?.name && (
                                                            <div className={`w-8 h-8 flex-none flex items-center justify-center align-middle rounded-full ${displayNameColoring(state.data.actor?.name.charAt(0))}`}>
                                                                <span className="text-white text-base font-medium">
                                                                    {state.data.actor?.name.charAt(0)}
                                                                </span>
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            ) : (
                                                <img className="rounded-full w-8 h-8 flex-none" src={state.data.actor?.photo_url} alt={`${state.data.actor?.name} avatar`} />
                                            )
                                        }

                                        <div className="flex-grow flex flex-col">
                                            <p className="text-sm text-stone-800 dark:text-white mb-">{state.data.actor?.name}</p>
                                            <p className="text-xs text-muted">{state.data.actor?.email}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full border-b border-slate-300 dark:border-slate-600"></div>
                        </div>

                        {
                            state.data.target && (
                                <div className="w-full px-4 md:px-5 pt-3 text-sm">
                                    <span className="block text-slate-800 dark:text-slate-200 mt-1 mb-1">
                                        Target Resource
                                    </span>

                                    <pre className="bg-slate-100 dark:bg-slate-900 text-slate-500 dark:text-white text-sm p-4 rounded-md overflow-auto">
                                        <code>{JSON.stringify(state.data.target, null, 4)}</code>
                                    </pre>

                                </div>
                            )
                        }

                        {
                            state.data.snapshot && (
                                <div className="w-full px-4 md:px-5 pt-3 text-sm">
                                    <span className="block text-slate-800 dark:text-slate-200 mt-1 mb-1">
                                        Data Snapshot
                                    </span>

                                    <pre className="bg-slate-100 dark:bg-slate-900 text-slate-500 dark:text-white text-sm p-4 rounded-md overflow-auto">
                                        <code>{JSON.stringify(state.data.snapshot, null, 4)}</code>
                                    </pre>

                                </div>
                            )
                        }
                    </>
                }
            />
        </React.Fragment>
    )
}